module.exports = __webpack_public_path__ + "img/arrow-90deg-right.77939e12.svg";